import { PayrollOrCompensationsAvailableDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export const usePayrollPaywallingGuard = () => {
  const { company } = useCurrentSession()
  const { data: featuresData, loading } = useQuery(PayrollOrCompensationsAvailableDocument, {
    variables: { companyId: company.id },
  })
  const featureAvailabilities =
    featuresData?.companies?.featureAvailabilitiesConnection?.nodes || []
  const features = featuresData?.features?.featuresConnection?.nodes || []
  const payrollManagementAvailable = featureAvailabilities.find(
    (feature) => feature?.id == 'payroll_management'
  )
  const compensationsManagementAvailable = featureAvailabilities.find(
    (feature) => feature?.id == 'compensations_management'
  )
  const devPackagingPaywallsAvailable = features.find(
    (feature) => feature.name == 'dev_packaging_paywalls'
  )
  const payrollBundleAvailable = features.find((feature) => feature.name == 'payroll_bundle')

  // If the company is still on the old packaging, we want them to still access payroll
  // (so paywalls are not enabled)
  if (!devPackagingPaywallsAvailable?.enabled) {
    return {
      isPayrollAvailable: payrollBundleAvailable?.enabled,
      loadingFeatures: loading,
    }
  }
  const hasPayrollOrCompensationsManagement =
    payrollManagementAvailable?.available || compensationsManagementAvailable?.available
  const available =
    hasPayrollOrCompensationsManagement == undefined ? false : hasPayrollOrCompensationsManagement

  return {
    isPayrollAvailable: available,
    loadingFeatures: loading,
  }
}
